import type { ThemeColors } from '@/domain/models/theme.js';
import type { GetDefaultTheme, UpdateDefaultTheme } from '@/domain/use-cases/theme.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';

export class ThemeController extends BaseControllerImpl {
    constructor(
        private readonly getDefaultThemeUseCase: GetDefaultTheme,
        private readonly updateDefaultThemeUseCase: UpdateDefaultTheme
    ) {
        super();
    }

    public async getDefaultTheme() {
        return this.getDefaultThemeUseCase.execute();
    }

    public async updateDefaultTheme(colors: ThemeColors) {
        return this.updateDefaultThemeUseCase.execute(colors);
    }
}
